import { useAuth } from '../contexts/AuthContext';

const TRIAL_DAYS = 14;

const useTrialStatus = () => {
  const { user } = useAuth();

  if (!user?.created_at) {
    return { daysRemaining: TRIAL_DAYS, trialExpired: false, showCountdown: false };
  }

  const createdAt = new Date(user.created_at).getTime();
  const daysSinceSignup = Math.floor((Date.now() - createdAt) / 86400000);
  const daysRemaining = Math.max(0, TRIAL_DAYS - daysSinceSignup);
  const trialExpired = daysSinceSignup > TRIAL_DAYS;
  const showCountdown = daysRemaining <= 4 || trialExpired;

  return { daysRemaining, trialExpired, showCountdown };
};

export default useTrialStatus;
